import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationAlertLevel } from '../notification-alert-level.enum';

export interface SnackbarNotificationsData {
  icon: string | undefined,
  message: string
}

@Component({
    selector: 'app-snackbar-notification',
    templateUrl: './snackbar-notification.component.html',
    styleUrls: ['./snackbar-notification.component.scss'],
    standalone: false
})
export class SnackbarNotificationComponent implements OnInit {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarNotificationsData,
    private readonly snackRef: MatSnackBarRef<SnackbarNotificationComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.snackRef.dismiss()
  }

}
